import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthApi } from '../api.gen';
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { ActiveDirectoryService } from '../active-directory.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AntiForgeryResolver  {

    constructor(
        private authApi: AuthApi,
        private adService: ActiveDirectoryService,
        private cookieService: CookieService,
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {

        this.adService.me().subscribe();
      return this.authApi.getAntiforgeryToken()
        .pipe(tap((resp) => {
          this.cookieService.set("XSRF-TOKEN", resp, {secure:true, sameSite:"None"});
        }));
    }

}

